module.exports = __webpack_public_path__ + "img/ig-logo.0ee55b1a.svg";